const _ = require('lodash');
import { UtilityService } from '../utility.service';
import { Consent } from '../../dataTypes/type-consent';
import { LanguageCode } from '../../Enums/LanguageCode.enums';
const moment = require('moment/moment');

/**
 * Service responsible for several history tasks.
 * Correctly translating the relative time and fetching the sorted history of a consent.
 */
export class HistoryLabelService {
    private utilityService: UtilityService;

    constructor(utilityService) {
        this.utilityService = utilityService;
    }

    /**
     * this function updates the labels of relative time whenever language is changed.
     */
    momentUpdateLocale() {
        const self = this;
        moment.updateLocale(LanguageCode.default, {
            relativeTime: {
                future: 'in %s',
                past: '%s ' + self.utilityService.settingsService.settings.labels.ago,
                m: self.utilityService.settingsService.settings.labels.minute,
                mm: '%d ' + self.utilityService.settingsService.settings.labels.minutes,
                h: self.utilityService.settingsService.settings.labels.hour,
                hh: '%d ' + self.utilityService.settingsService.settings.labels.hours,
                d: self.utilityService.settingsService.settings.labels.day,
                dd: '%d ' + self.utilityService.settingsService.settings.labels.days,
                M: self.utilityService.settingsService.settings.labels.month,
                MM: '%d ' + self.utilityService.settingsService.settings.labels.months,
                y: self.utilityService.settingsService.settings.labels.year,
                yy: '%d ' + self.utilityService.settingsService.settings.labels.years
            }
        });
        moment.fn.fromNowOrNow = function(a) {
            if (Math.abs(moment().diff(this)) < 60000) {
                // 60 sec
                return self.utilityService.settingsService.settings.labels.justNow;
            }
            return this.fromNow(a);
        };
    }

    /**
     * concat history of all consents and sort it by time
     * @param consents 
     */
    static getFullHistoryList(consents: Consent.Consent[]) {
        let history = [];
        consents.forEach(consent => {
            if (consent.history && consent.history.length) {
                history = history.concat(consent.history);
            }
        });
        return history.sort((a, b) => {
            if (a.updatedAt < b.updatedAt) {
                return 1;
            }
            if (a.updatedAt > b.updatedAt) {
                return -1;
            }
            return 0;
        });
    }

}
